let setErrorRef: ((msg: string | null) => void) | null = null;

export const registerGlobalErrorSetter = (fn: (msg: string | null) => void) => {
  setErrorRef = fn;
};

export const pushGlobalError = (msg: string | null) => {
  if (setErrorRef) setErrorRef(msg);
};

export const unregisterGlobalErrorSetter = () => {
  setErrorRef = null;
};
